export const hasDirectContactFields = (inquiry) =>
  inquiry?.fname && inquiry?.lname && inquiry?.email

export const splitFullNameForEnroll = (fullName) => {
  if (!fullName || fullName === 'N/A') {
    return { firstName: '', lastName: '' }
  }
  const trimmed = String(fullName).trim()
  const parts = trimmed.split(/\s+/).filter(Boolean)
  if (parts.length === 0) {
    return { firstName: '', lastName: '' }
  }
  if (parts.length === 1) {
    return { firstName: parts[0], lastName: '' }
  }
  return { firstName: parts[0], lastName: parts.slice(1).join(' ') }
}

export const getInquiryDisplayContact = (inquiry) => {
  if (hasDirectContactFields(inquiry)) {
    return {
      fullName: [inquiry.fname, inquiry.lname].filter(Boolean).join(' ').trim(),
      email: inquiry.email,
    }
  }

  const fullNameAnswer = inquiry.answers?.find(
    (answer) =>
      answer.question === 'FULL NAME' &&
      answer.answer &&
      answer.answer.length > 0,
  )
  const emailAnswer = inquiry.answers?.find(
    (answer) =>
      answer.question === 'EMAIL' && answer.answer && answer.answer.length > 0,
  )

  return {
    fullName: fullNameAnswer ? fullNameAnswer.answer[0] : 'N/A',
    email: emailAnswer ? emailAnswer.answer[0] : 'N/A',
  }
}

export const getInquiryEnrollPrefill = (inquiry) => {
  const { fullName, email } = getInquiryDisplayContact(inquiry)
  const { firstName, lastName } = hasDirectContactFields(inquiry)
    ? { firstName: inquiry.fname, lastName: inquiry.lname }
    : splitFullNameForEnroll(fullName)

  return {
    email: email && email !== 'N/A' ? email : '',
    firstName,
    lastName,
  }
}
